import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import reportWebVitals from "./reportWebVitals";
import Register from "./components/register";
import Login from "./components/login";
import Home from "./components/home";
import Withdraw from "./components/dashboard/withdraw";
import ChangeWalletOwner from "./components/dashboard/ChangeWalletOwner";

import ChangeWallet from "./components/dashboard/ChangeWallet";
import ChangeWalletByOwner from "./components/dashboard/ChangeWalletByOwner";
import RecycleContractFunds from "./components/dashboard/RecycleContractFunds";
import AutoUpgradeContractFunds from "./components/dashboard/AutoUpgradeContractFunds";
import ChangeClaimPeriod from "./components/dashboard/ChangeClaimPeriod";

import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { polygon, bscTestnet } from 'viem/chains'

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = 'e63e14d0267d9da4773ea06e9d9e521e' 
// const projectId = 'ae64d2d938316ce3350fea4c10f6cc79'


// 2. Create wagmiConfig
const metadata = {
  name: 'Vmines Network',
  description: 'Vmines Network',
  url: 'https://vmines.network/',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}
const chains = [polygon]
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="" element={<Home />} />
      {/* <Route path="/h2Old" element={<Home2 />} /> */}
      {/* <Route path="join" element={<Register />} /> */}
      {/* <Route path="login" element={<Login />} /> */}
      <Route path="withdraw" element={<Withdraw />} />
      <Route path="wchange" element={<ChangeWallet />} />

      <Route path="holderfunds" element={<RecycleContractFunds />} />

      <Route path="ochange" element={<ChangeWalletOwner />} />
      <Route path="changebyadmin" element={<ChangeWalletByOwner />} /> 
      <Route path="*" element={<DashboardLayout />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
